'use client';

import { SortIcon } from '../../../../../icons/sort/sort';
import type { TableColumnSortDirection } from '../../../util/column-sort';
import styles from './column-sort.module.scss';

function buildSortAriaLabel(direction: TableColumnSortDirection | undefined, name: string) {
  switch (direction) {
    case 'asc':
      return `Remove sort from ${name} (currently ascending)`;
    case 'desc':
      return `Sort ${name} in ascending order (currently descending)`;
    default:
      return `Sort ${name} in descending order (currently unsorted)`;
  }
}

interface ColumnSortProps {
  direction: TableColumnSortDirection | undefined;
  name: string;
  onSort: ((event: unknown) => void) | undefined;
}

export function ColumnSort({ direction, name, onSort }: ColumnSortProps) {
  return (
    <button aria-label={buildSortAriaLabel(direction, name)} className={styles.columnSort} onClick={onSort} type="button">
      <SortIcon height={16} sort={direction} width={16} />
    </button>
  );
}
